import { observer } from "mobx-react";
import React, { useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  CircularProgress,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";
import MyPageStore from "pages/MyPage/store/MyPageStore";
import emailIcon from "../../../../assets/image/sms.png";
import { TaskModel } from "domains/models/TaskModel";
import useSnackbarMessage from "shared/snackbar";
import { AssessModel } from "domains/models/AssessModel";
import styled from "@emotion/styled";
import bluePin from "../../../../assets/image/bluePin.png";
import redPin from "../../../../assets/image/redPin.png";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import BasicImage from "pages/MyPage/component/BasicImage";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import moment from "moment";
import ImageIcon from "@mui/icons-material/Image";
import { useMediaQueryState } from "../../../../hooks/useMediaQueryState";
import { useRootStore } from "store/StoreContextProvider";

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  "&::before": {
    display: "none",
  },
  "& .MuiButtonBase-root .MuiAccordionSummary-root .Mui-expanded": {
    minHeight: "42px",
  },
  "& .MuiAccordionSummary-content": {
    margin: "0px",
  },
  "& .MuiAccordionDetails-root": {
    padding: 0,
  },
}));

interface Props {
  pageStore: MyPageStore;
}

function MyPageScoreDetailBody(props: Props) {
  const { pageStore } = props;
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const snackbar = useSnackbarMessage();
  const { loginStore } = useRootStore();
  const location = useLocation();
  const { isPC } = useMediaQueryState();
  const [flag, setFlag] = React.useState<boolean>(true);

  useEffect(() => {
    fetchTaskListOfStatus();
  }, []);

  const fetchTaskListOfStatus = async () => {
    try {
      const myInfo = location.state.myInfo;
      pageStore.setMyInfo(myInfo);
      await pageStore.fetchTaskListOfStatus(myInfo);
      await loginStore.fetchConfigSettings();
    } catch (err: any) {
      snackbar.error(err.message);
    }
  };

  const handleChangeAccordion =
    (task: AssessModel, panel: string) =>
    (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
      // setSelectedTask(task);
    };

  const renderPrimary = (task: TaskModel) => {
    if (task.subtype === "CHAT") {
      if (task.userData?.body?.contentType === "html") {
        let content = task.userData?.body?.content;
        content = content
          ?.split("<")
          .filter((el: any) => !el.startsWith("img"))
          .filter((el: any) => !el.startsWith("div>&nbsp"))
          ?.join("<");
        return (
          <div>
            <div
              style={{
                maxHeight: "49px",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "16px",
                color: "#171918",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              dangerouslySetInnerHTML={{
                __html: content as any,
              }}
            ></div>
            <p
              style={{
                fontFamily: "Pretendard",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "12px",
                color: "#ABABAB",
              }}
            >
              {moment(task.userData.createdDateTime).format("YYYY/MM/DD")}
            </p>
          </div>
        );
      } else {
        let content = task.userData?.body?.content?.split("<")[0];

        return (
          <div
            style={{
              fontStyle: "normal",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "16px",
              color: "#171918",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {task.userData?.body?.content}
            <p
              style={{
                fontFamily: "Pretendard",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "12px",
                color: "#ABABAB",
              }}
            >
              {moment(task.userData?.createdDateTime).format("YYYY/MM/DD")}
            </p>
          </div>
        );
      }
    } else {
      if (task.userData?.bodyPreview) {
        return (
          <div
            style={{
              fontStyle: "normal",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "16px",
              color: "#171918",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {task.title}
            <p
              style={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "14px",
                color: "#171918",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {task.userData?.bodyPreview}
            </p>
            <p
              style={{
                fontFamily: "Pretendard",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "12px",
                color: "#ABABAB",
              }}
            >
              {moment(task.userData?.receivedDateTime).format("YYYY/MM/DD")}
            </p>
          </div>
        );
      }
      return (
        <div
          style={{
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "16px",
            color: "#171918",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {task.title}
          <p
            style={{
              fontFamily: "Pretendard",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "12px",
              lineHeight: "12px",
              color: "#ABABAB",
            }}
          >
            {moment(task.userData?.receivedDateTime).format("YYYY/MM/DD")}
          </p>
        </div>
      );
    }
  };

  const renderTask = (children: AssessModel[] | undefined, task: TaskModel) => {
    if (children?.length === 0) {
      return <Typography key={task.id}>코멘트가 없습니다.</Typography>;
    }
    if (pageStore.tabValue === "downwards") {
      return children?.map((child: AssessModel) => {
        if (pageStore.myInfo.userData?.downwardsList) {
          let tempList = pageStore.myInfo.userData.downwardsList.map(
            (li) => li.id
          );
          if (tempList.includes(child.userId)) {
            if (child.userData?.skip === false) {
              return <></>;
            }
            if (child.title) {
              return (
                <ListItem key={child.created} style={{}}>
                  {child.user?.userData?.profile ? (
                    <BasicImage
                      src={child.user?.userData?.profile}
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: "50%",
                        objectFit: "cover",
                        overflow: "hidden",
                      }}
                    />
                  ) : (
                    <Avatar>
                      <ImageIcon
                        sx={{
                          borderRadius: "50%",
                          objectFit: "cover",
                          overflow: "hidden",
                        }}
                      />
                    </Avatar>
                  )}

                  <ListItemText
                    primary={
                      <span
                        style={{
                          fontFamily: "Pretendard",
                          fontStyle: "normal",
                          fontWeight: 600,
                          fontSize: "16px",
                          lineHeight: "16px",
                          color: "#000000",
                        }}
                      >
                        {child.user?.names?.fullname}
                        <span
                          style={{
                            fontFamily: "Pretendard",
                            fontStyle: "normal",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "14px",
                            color: "#212121",
                            marginLeft: "4px",
                          }}
                        >
                          {child.user?.userData.jobTitle}
                          <span
                            style={{
                              fontWeight: 400,
                              fontSize: "12px",
                              lineHeight: "12px",
                              color: "#6C6B6F",
                              marginLeft: "4px",
                            }}
                          >
                            {child.user?.userData.deptName}
                          </span>
                          {loginStore.isPublic ? (
                            child.subtype === "INVISIBLE" ? (
                              <span
                                style={{
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  lineHeight: "14px",
                                  color: "#212121",
                                  float: "right",
                                  marginTop: "5px",
                                  marginRight: "10px",
                                }}
                              >
                                평가점수:{child?.userData?.grade}점
                              </span>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </span>
                      </span>
                    }
                    secondary={
                      child.subtype === "VISIBLE" ? (
                        <Typography
                          style={{
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "14px",
                            color: "#171918",
                            marginTop: "4px",
                            width: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {child.title}
                        </Typography>
                      ) : (
                        <></>
                      )
                    }
                    // onClick={(e) => handleClickEmployee(employee)}
                    style={{
                      margin: 0,
                      marginLeft: "16px",
                    }}
                  />

                  {renderLockIcon(child)}
                  {renderPinIcon(child)}
                </ListItem>
              );
            }
          }
        }
      });
    } else if (pageStore.tabValue === "peer") {
      return children?.map((child: AssessModel) => {
        if (pageStore.myInfo.userData.peerList) {
          let tempList = pageStore.myInfo.userData.peerList.map((li) => li.id);

          if (tempList.includes(child.userId)) {
            if (child.userData?.skip === false) {
              return <></>;
            }
            if (child.id) {
              return (
                <ListItem key={child.created} style={{}}>
                  <Avatar>
                    <ImageIcon
                      sx={{
                        borderRadius: "50%",
                        objectFit: "cover",
                        overflow: "hidden",
                      }}
                    />
                  </Avatar>

                  <ListItemText
                    primary={
                      <span
                        style={{
                          fontFamily: "Pretendard",
                          fontStyle: "normal",
                          fontWeight: 600,
                          fontSize: "16px",
                          lineHeight: "16px",
                          color: "#000000",
                        }}
                      >
                        익명
                        {loginStore.isPublic ? (
                          child.subtype === "INVISIBLE" ? (
                            <span
                              style={{
                                fontWeight: 400,
                                fontSize: "14px",
                                lineHeight: "14px",
                                color: "#212121",
                                float: "right",
                                marginTop: "5px",
                                marginRight: "10px",
                              }}
                            >
                              평가점수:{child?.userData?.grade}점
                            </span>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </span>
                    }
                    secondary={
                      child.subtype === "VISIBLE" ? (
                        <Typography
                          style={{
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "14px",
                            color: "#171918",
                            marginTop: "4px",
                            width: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {child.title}
                        </Typography>
                      ) : (
                        <></>
                      )
                    }
                    // onClick={(e) => handleClickEmployee(employee)}
                    style={{
                      margin: 0,
                      marginLeft: "16px",
                    }}
                  />

                  {renderLockIcon(child)}
                  {renderPinIcon(child)}
                </ListItem>
              );
            }
          }
        }
      });
    } else {
      return children?.map((child: AssessModel, index: number) => {
        if (child.id) {
          if (child.userData?.skip === false) {
            return <></>;
          }

          return (
            <ListItem
              key={child.created}
              style={{
                background: child.userData.isPeer ? "#2281D0" : "",
                borderBottomLeftRadius:
                  children.length - 1 === index ? "12px" : "",
                borderBottomRightRadius:
                  children.length - 1 === index ? "12px" : "",
                borderTop: "1px solid #6C6B6F",
                borderLeft: "1px solid #6C6B6F",
                borderRight: "1px solid #6C6B6F",
              }}
            >
              {child.userData.isPeer ? (
                <Avatar>
                  <ImageIcon
                    sx={{
                      borderRadius: "50%",
                      objectFit: "cover",
                      overflow: "hidden",
                    }}
                  />
                </Avatar>
              ) : child.user?.userData?.profile ? (
                <BasicImage
                  src={child.user?.userData?.profile}
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    objectFit: "cover",
                    overflow: "hidden",
                  }}
                />
              ) : (
                <Avatar>
                  <ImageIcon
                    sx={{
                      borderRadius: "50%",
                      objectFit: "cover",
                      overflow: "hidden",
                    }}
                  />
                </Avatar>
              )}

              <ListItemText
                primary={
                  <span
                    style={{
                      fontFamily: "Pretendard",
                      fontStyle: "normal",
                      fontWeight: 600,
                      fontSize: "16px",
                      lineHeight: "16px",
                      color: "#000000",
                    }}
                  >
                    {child.userData.isPeer
                      ? "익명"
                      : child.user?.names?.fullname}
                    <span
                      style={{
                        fontFamily: "Pretendard",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "14px",
                        color: "#212121",
                        marginLeft: "4px",
                      }}
                    >
                      {child.userData.isPeer
                        ? ""
                        : child.user?.userData.jobTitle}
                      <span
                        style={{
                          fontWeight: 400,
                          fontSize: "12px",
                          lineHeight: "12px",
                          color: "#6C6B6F",
                          marginLeft: "4px",
                        }}
                      >
                        {child.userData.isPeer
                          ? ""
                          : child.user?.userData.deptName}
                      </span>
                      {loginStore.isPublic ? (
                        child.subtype === "INVISIBLE" ? (
                          <span
                            style={{
                              fontWeight: 400,
                              fontSize: "14px",
                              lineHeight: "14px",
                              color: "#212121",
                              float: "right",
                              marginTop: "5px",
                              marginRight: "10px",
                            }}
                          >
                            평가점수:{child?.userData?.grade}점
                          </span>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </span>
                }
                secondary={
                  child.subtype === "VISIBLE" ? (
                    <Typography
                      style={{
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "14px",
                        color: "#171918",
                        marginTop: "4px",
                        width: "200px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {child.title}
                    </Typography>
                  ) : (
                    <></>
                  )
                }
                // onClick={(e) => handleClickEmployee(employee)}
                style={{
                  margin: 0,
                  marginLeft: "16px",
                }}
              />

              {renderLockIcon(child)}
              {renderPinIcon(child)}
            </ListItem>
          );
        }
      });
    }
  };

  const renderEmoticion = (children: AssessModel[] | undefined) => {
    if (pageStore.tabValue === "downwards") {
      return children?.map((child: AssessModel) => {
        if (pageStore.myInfo.userData.downwardsList) {
          let tempList = pageStore.myInfo.userData.downwardsList.map(
            (li) => li.id
          );
          if (tempList.includes(child.userId)) {
            return (
              <span key={child.id}>
                {child.userData?.emoticon ? child.userData?.emoticon : ""}
              </span>
            );
          }
        }
      });
    } else if (pageStore.tabValue === "peer") {
      if (pageStore.myInfo.userData.peerList) {
        return children?.map((child: AssessModel) => {
          if (pageStore.myInfo.userData.peerList) {
            let tempList = pageStore.myInfo.userData.peerList.map(
              (li) => li.id
            );
            if (tempList.includes(child.userId)) {
              return (
                <span key={child.id}>
                  {child.userData?.emoticon ? child.userData?.emoticon : ""}
                </span>
              );
            }
          }
        });
      }
    } else {
      return children?.map((child: AssessModel) => {
        return (
          <span key={child.id}>
            {child.userData?.emoticon ? child.userData?.emoticon : ""}
          </span>
        );
      });
    }
  };

  const renderLockIcon = (child: AssessModel) => {
    if (child.subtype === "VISIBLE") {
      return <LockOpenIcon />;
    } else {
      return <LockIcon />;
    }
  };
  const renderPinIcon = (child: AssessModel) => {
    if (child.userData?.like === "true") {
      return <img src={bluePin} alt="bluePin" />;
    } else if (child.userData?.like === "false") {
      return <img src={redPin} alt="redPin" />;
    }
  };

  return (
    <Grid style={{ padding: "0px 20px 80px 20px" }}>
      <Paper style={{ position: "relative", boxShadow: "none" }}>
        <List
          dense={false}
          style={isPC ? {} : { height: "500px", overflowY: "scroll" }}
        >
          {pageStore.isLoading ? (
            <Grid
              container
              justifyContent={"center"}
              style={{ marginTop: "150px" }}
            >
              <CircularProgress />
            </Grid>
          ) : (
            pageStore.assessList.map((assess: any, index) => {
              return (
                <StyledAccordion
                  key={assess[0].id}
                  expanded={expanded === `panel${assess[0].id}`}
                  onChange={handleChangeAccordion(
                    assess[0],
                    `panel${assess[0].id}`
                  )}
                  style={{
                    // border: "1px solid #dddddd",
                    marginBottom: "14px",
                    borderRadius: "15px",
                  }}
                >
                  <AccordionSummary
                    sx={{
                      justifyContent: "normal",
                      padding: 0,
                      display: "block",
                      position: "relative",
                    }}
                    id={`panel${index}bh-header`}
                  >
                    <ListItem>
                      <div
                      //  onClick={() => handleClickPanel(`panel${task.id}`)}
                      >
                        {expanded === `panel${assess[0].id}` ? (
                          <ExpandLessIcon
                            style={{
                              position: "absolute",
                              bottom: "15px",
                              right: "10px",
                            }}
                          />
                        ) : (
                          <ExpandMoreIcon
                            style={{
                              position: "absolute",
                              bottom: "15px",
                              right: "10px",
                            }}
                          />
                        )}
                      </div>
                      <ListItemAvatar>
                        <Avatar
                          style={{
                            background: "#EBF8F5",
                          }}
                        >
                          <img src={emailIcon} alt="emailIcon" />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={renderPrimary(assess[0].parent)}
                        secondary={renderEmoticion(assess)}
                      />
                    </ListItem>
                  </AccordionSummary>
                  <AccordionDetails>
                    {renderTask(assess, assess[0].parent)}
                  </AccordionDetails>
                </StyledAccordion>
              );
            })
          )}
        </List>
      </Paper>
    </Grid>
  );
}

export default observer(MyPageScoreDetailBody);
